import { useState } from 'react'

/**
 * Hook to manage ActiveSingleJob UI state
 *
 * Historia 148 (S8): dejó de gestionar la ventana documental de un solo tipo de recurso
 * (`openDocument` / `handleOpenMaterialsSheet` / `handleCloseMaterialsSheet` / `isDownloadingFile`).
 * Ese acceso —el icono «Open materials sheet», que además identificaba el job por el nodo del
 * workflow— lo sustituye el botón compartido `common/documents/FabricationDocumentsButton`, que
 * abre la documentación de la fabricación entera y lleva su propio estado.
 */
export const useActiveSingleJob = () => {
  const [tabValue, setTabValue] = useState(0)

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  return {
    tabValue,
    handleTabChange
  }
}
